import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Route } from 'react-router';

import Home from './Home';
import Control from './Control/Control';

export default class App extends React.Component {
  state = {
    accepted: false
  };
  render() {
    console.log(this.state.accepted);
    return (
      <BrowserRouter>
        <div>
          <Route exact path="/" component={Home} />
          <Route path="/controle" component={Control} />
        </div>
      </BrowserRouter>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js